import axios from "axios";
import { Middleware } from "@reduxjs/toolkit";
import { logout } from "../features/authSlice";

    const baseUrl = process.env.REACT_APP_BASE_URL;

export const logoutMiddleware: Middleware =
  () => (next) => async (action:any) => {
    if (action.type === logout.type) {
      try {
        const token = JSON.parse(localStorage.getItem("authToken") || "null");

        if (token?.access_token) {
          await axios.post(
            `${baseUrl}api/logout`,
            {},
            {
              headers: {
                Authorization: `${token.token_type} ${token.access_token}`,
                "Content-Type": "application/json",
              },
            }
          );
        }
      } catch (error) {
        console.error("Logout API failed:", error);
      }
    }
    
    return next(action);
  };
